import { trustStats } from "@/mocks/seoContent";

export default function Hero() {
  return (
    <section className="relative min-h-[620px] md:min-h-[720px] flex items-center pt-16 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Sneakers%20and%20streetwear%20items%20arranged%20on%20a%20rustic%20oak%20wooden%20surface%20near%20large%20floor-to-ceiling%20windows%20with%20soft%20morning%20light%20filtering%20through%20editorial%20lifestyle%20photography%20with%20depth%20of%20field%20blur%20on%20background%20warm%20earth%20tones%20scandinavian%20interior%20with%20potted%20plants%20visible%20fashion%20catalog%20aesthetic&width=1600&height=900&seq=hero-bg-pandabuy-v2&orientation=landscape"
          alt="Curated pandabuy spreadsheet fashion finds collage"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-white/25 to-white/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold mb-6 border border-accent-200/40">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              Updated Daily
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-[1.08] tracking-tight text-balance drop-shadow-sm">
              PandabuySpreadsheet
              <br />
              <span className="text-primary-600">Curated Daily</span>
            </h1>
            <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-700 max-w-lg leading-relaxed font-medium">
              The most comprehensive curated pandabuy spreadsheet database. Discover viral sneakers, streetwear, and accessories organized into structured categories — updated every single day.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-7">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer text-center whitespace-nowrap flex items-center justify-center gap-2"
              >
                Explore Spreadsheet Hub
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 rounded-full border border-foreground-400 bg-background-50/70 text-foreground-800 text-sm font-medium hover:bg-background-100/80 transition-colors cursor-pointer text-center whitespace-nowrap flex items-center justify-center gap-2"
              >
                Pandabuy Sheet
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative rounded-[32px] overflow-hidden h-[320px] md:h-[400px] w-full shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Collection%20of%20premium%20sneakers%20and%20accessories%20neatly%20arranged%20on%20a%20marble%20countertop%20from%20a%2045-degree%20angle%20dramatic%20side%20lighting%20creating%20crisp%20shadows%20clean%20minimalist%20luxury%20retail%20environment%20muted%20color%20palette%20with%20pops%20of%20terracotta%20and%20sage%20green%20editorial%20product%20showcase&width=1200&height=800&seq=hero-display-pandabuy-v2&orientation=landscape"
                alt="Curated fashion finds flat lay"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 rounded-[32px] ring-1 ring-inset ring-background-200/40"></div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-6 md:gap-10 mt-12 md:mt-16 pb-4">
          {trustStats.map((stat, i) => (
            <div key={i} className="flex items-center gap-2">
              <span className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">{stat.value}</span>
              <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">{stat.label}</span>
              {i < trustStats.length - 1 && (
                <span className="w-px h-5 bg-background-300 ml-2"></span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}